import { createAction, props } from '@ngrx/store';
import { IRisk } from '../../models';

export const setSelectedRisks = createAction('risks.selected.set', props<{ ids: number[] }>());
export const clearSelectedRisks = createAction('risks.selected.clear');

export const loadRisks = createAction('risks.load', props<{ risks: IRisk[] }>());
export const loadRisksSuccess = createAction('risks.load.success', props<{ risks: IRisk[] }>());
export const loadRisksError = createAction('risks.load.error');
